import { z } from "zod";
import { readStoredSetting, writeStoredSetting } from "../persistence/database";

const APPLICATION_SETTINGS_KEY = "applicationSettings";

export const applicationSettingsSchema = z.object({
  uiScale: z.union([z.literal(100), z.literal(112.5), z.literal(125)]),
});

export type ApplicationSettings = z.infer<typeof applicationSettingsSchema>;

export const defaultApplicationSettings: ApplicationSettings = { uiScale: 100 };

export async function loadApplicationSettings() {
  const value = await readStoredSetting(APPLICATION_SETTINGS_KEY);
  if (!value) return defaultApplicationSettings;
  try {
    return applicationSettingsSchema.parse(JSON.parse(value));
  } catch {
    return defaultApplicationSettings;
  }
}

export async function saveApplicationSettings(value: ApplicationSettings) {
  const settings = applicationSettingsSchema.parse(value);
  await writeStoredSetting(APPLICATION_SETTINGS_KEY, JSON.stringify(settings));
  applyApplicationSettings(settings);
  return settings;
}

export function applyApplicationSettings(value: ApplicationSettings) {
  document.documentElement.dataset.uiScale = String(value.uiScale).replace(".5", "-5");
}
